import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { SplitViewObserverService } from './split-view-observer.service';

@Component({
    selector: 'ldw-split-view',
    templateUrl: './split-view.component.html',
    styleUrls: ['./split-view.component.css'],
    standalone: false
})
export class SplitViewComponent implements OnChanges {
  private splitViewObserver = inject(SplitViewObserverService);

  gutterSize = 6;
  listSize = 40;
  detailSize = 60;
  busy = false;
  @Input() useSplitMode = true;
  @Input() hasDetail = false;

  constructor() {
    this.setSplit();
  }

  notifySplitviewMoved(event: { gutterNum: number }) {
    this.splitViewObserver.notifyMoved(event);
    this.notifySplitviewMoving(false);
  }

  notifySplitviewMoving(isMoving: boolean) {
    this.busy = isMoving;
    this.splitViewObserver.notifyMoving(isMoving);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.useSplitMode || changes.hasDetail) {
      this.updateMode();
    }
  }

  updateMode() {
    if (this.useSplitMode) {
      this.setSplit();
    } else {
      if (this.hasDetail) {
        this.setDetail();
      } else {
        this.setList();
      }
    }
  }

  setSplit() {
    this.gutterSize = 6;
    this.listSize = 40;
    this.detailSize = 60;
  }

  setList() {
    this.gutterSize = 0;
    this.listSize = 100;
    this.detailSize = 0;
  }

  setDetail() {
    this.gutterSize = 0;
    this.listSize = 0;
    this.detailSize = 100;
  }
}
